import { useQuery } from 'react-query';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';

export const useQueryRelationshipTypeChangesTableData = (params, endpoint?: string) => {
    return useQuery({
        queryKey: ['relationshipTypeChangesTableData', params],
        queryFn: () => queryFn(params, endpoint),
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
